module.exports = __webpack_public_path__ + "static/media/custProfile.9c63aafe.pdf";